import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function LinkTelegramPage() {
  const { t } = useTranslation("auth");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? undefined;
  const [status, setStatus] = useState<"loading" | "ok" | "error">("loading");

  useEffect(() => {
    document.title = "Link Telegram — Content OS";
  }, []);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!token) {
        setStatus("error");
        return;
      }
      try {
        const res = await fetch(
          `/api/link-telegram?token=${encodeURIComponent(token)}`,
          { credentials: "include", cache: "no-store" },
        );
        if (!cancelled) setStatus(res.ok ? "ok" : "error");
      } catch {
        if (!cancelled) setStatus("error");
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div style={{ fontFamily: "system-ui, sans-serif", maxWidth: 560, margin: "64px auto", padding: "0 24px" }}>
      <h1 style={{ fontSize: 20, margin: 0 }}>Content OS</h1>
      <div style={{ marginTop: 24 }}>
        {status === "loading" ? (
          <p>{t("linkTelegram.linking")}</p>
        ) : status === "ok" ? (
          <>
            <h2 style={{ fontSize: 18 }}>{t("linkTelegram.successTitle")}</h2>
            <p>{t("linkTelegram.successMessage")}</p>
            <p><a href="/settings/notifications">{t("linkTelegram.manageNotifications")}</a></p>
          </>
        ) : (
          <>
            <h2 style={{ fontSize: 18 }}>{t("linkTelegram.errorTitle")}</h2>
            <p>{t("linkTelegram.errorMessage")}</p>
          </>
        )}
      </div>
    </div>
  );
}
